<template>
    <div
        class="select"
        :class="disabled ? 'select_disabled' : ''"
    >
        <div
            class="select__title" @click="toggle"
            :class="show ? 'select__title_active' : ''"
        >
            {{ active != null && !!list[active].title ? list[active].title : '' }}
        </div>

        <div
            class="select__placeholder"
            v-if="placeholder && active == null"
        >
            {{ placeholder }}
        </div>

        <transition name="fade">
            <div
                class="select__list"
                :class="'select__list_' + pos"
                v-if="show"
                v-bar
            >
                <div>
                    <div
                        class="select__item"
                        @click="onSelect(i)"
                        v-for="(item, i) in list"
                        :key="i"
                    >
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Select',

    props: {
        placeholder: {
            type: String,
            required: true,
        },
        list: {
            type: Array,
            required: true,
        },
        active: {
            required: true,
        },
        update: {
            type: Function,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        }
    },

    data: () => {
        return {
            show: false,
            pos: 'bottom',
        }
    },

    created() {
        window.addEventListener('click', this.close)
    },

    beforeDestroy() {
        window.removeEventListener('click', this.close)
    },

    methods: {
        onSelect(index) {
            this.show = false
            this.update(index)
        },

        toggle(event) {
            const
                $el = event.target,
                boundingRect = $el.getBoundingClientRect()

            this.show = !this.show
            this.pos = window.innerHeight - (boundingRect.top + 200) > 0 ? 'bottom' : 'top'
        },

        close(event) {
            if ( !this.$el.contains(event.target) ) {
                this.show = false
            }
        },
    },
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.select {
    font-family: 'Helvetica Neue', 'Segoe UI', 'Arial', sans-serif;
    border-bottom: 1px solid rgba(53, 53, 53, 1);
    position: relative;
    font-size: 22px;
    font-weight: 300;
    line-height: 1.5;
    transition: opacity .2s;

    &_disabled {
        pointer-events: none;
        opacity: .4;
    }

    @include bp('xs') {
        font-size: 30px;
        line-height: 1.5;
    }

    &__title {
        display: block;
        width: 100%;
        color: #fff;
        background: transparent;
        border: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        height: 33px;
        cursor: pointer;
        user-select: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        padding-right: 20px;

        @include bp('xs') {
            height: 45px;
        }

        &:after {
            position: absolute;
            content: '';
            width:  7px;
            height: 7px;
            border-top: 2px solid transparent;
            border-right: 2px solid transparent;
            border-bottom: 2px solid #666;
            border-left: 2px solid #666;
            right: 2px;
            top: 50%;
            transform: translateY(-50%) rotate(-45deg);
            transition: all .2s;

            @include bp('xs') {
                width:  10px;
                height: 10px;
            }
        }

        &_active {
            &:after {
                border-top: 2px solid #666;
                border-right: 2px solid #666;
                border-bottom: 2px solid transparent;
                border-left: 2px solid transparent;
                transform: translateY(0) rotate(-45deg);
            }
        }
    }

    &__placeholder {
        position: absolute;
        top: 0;
        left: 0;
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        color: rgba(68, 68, 68, 1);
        pointer-events: none;
        user-select: none;
    }

    &__list {
        position: absolute !important;
        background-color: #333;
        width: 100%;
        border-radius: 3px;
        z-index: 1;
        height: 155px;

        &_bottom {
            top: 33px;

            @include bp('xs') {
                top: 45px;
            }
        }

        &_top {
            bottom: 33px;

            @include bp('xs') {
                bottom: 45px;
            }
        }
    }

    &__item {
        cursor: pointer;
        color: #fff;
        transition: all .2s;
        user-select: none;
        font-size: .75em;
        padding: 5px 15px;
        // margin-bottom: 15px;

        // &:last-child {
        //     margin-bottom: 0;
        // }

        &:hover {
            color: #fb8c2b;
            background-color: rgba(0, 0, 0, .05);
        }
    }
}

.fade-enter-active, .fade-leave-active {
  transition: all .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}
</style>
